import React from 'react';
import { sendMessageToParent } from '../../helpers/messageProxy';
import './style.css';

export class Video extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canPlay: false,
    };
    this.videoReference = null;
  }

  componentDidMount() {
    this.videoReference.disablePictureInPicture = true;
    this.videoReference.addEventListener('loadedmetadata', this.onLoadVideoMetadata);
  }

  async componentWillReceiveProps({ playing }) {
    playing ? await this.videoReference.play() : await this.videoReference.pause();
  }

  onLoadVideoMetadata = event => {
    const { videoWidth, videoHeight } = event.target;
    const videoOrientation = videoHeight > videoWidth ? 'portrait' : 'landscape';
    sendMessageToParent({
      type: 'CHANGE_ORIENTATION',
      message: { videoOrientation, videoWidth, videoHeight }
    });
  }

  render() {
    const { canPlay } = this.state;
    const { onPause, onPlay, type, soundMuted, onVideoEnds } = this.props;
    const videoSource = `${this.props.source}#t=0.03`;

    return (
      <video
        ref={reference => this.videoReference = reference}
        className="video"
        style={{
          display: canPlay ? 'block' : 'none',
          pointerEvents: 'none'
        }}
        muted={soundMuted}
        autoPlay
        playsInline
        preload="auto"
        onCanPlay={() => {
          this.setState({ canPlay: true });
          this.props.onCanPlay();
        }}
        onPlay={onPlay}
        onPause={onPause}
        src={videoSource}
        onEnded={onVideoEnds}
      >
        <source src={videoSource} type={type} />
      </video>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/Video/Video.jsx